import { WithdrawalMetadata } from 'data/Payments/Withdrawal/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getFee = (currency: string) =>
  fetchApi<WithdrawalMetadata>({
    auth: true,
    method: 'GET',
    queryParams: { currency },
    url: getApiUrl('nabu-gateway/markets/exchange/withdrawal')
  })
